import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ib-play",
  "use": "icon-ib-play-usage",
  "viewBox": "0 0 1080 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1080 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ib-play\">\r\n    <path d=\"M908.458667 445.553778L375.637333 132.551111a113.777778 113.777778 0 0 0-176.128 103.651556v614.798222a113.777778 113.777778 0 0 0 172.430223 114.915555l539.306666-317.212444a113.777778 113.777778 0 0 0-2.844444-203.150222z\" p-id=\"9919\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol